import { type ReactNode, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetcher } from 'react-router-dom';

import ActionForm from '~/components/ActionForm';
import StatusInputs from '~/components/Forms/StatusInputs';
import useToast, { type ToastData } from '~/hooks/useToast';
import toast from '~/utils/toast';

type Props = {
  children: ({ isLoading, submitForm }: { isLoading: boolean; submitForm: () => void }) => ReactNode;
  onSuccess?: () => void;
  pauseId?: string | null;
  tierId?: string | null;
  subscriberId: string;
};

const UnpauseAction = ({ children, onSuccess, pauseId, tierId, subscriberId }: Props) => {
  const { t } = useTranslation();
  const fetcher = useFetcher<{
    toast?: ToastData;
  }>();
  const fetcherData = fetcher.data;
  const isLoading = fetcher.state === 'submitting';
  const formRef = useRef<HTMLFormElement>(null);

  useToast(fetcherData?.toast, onSuccess);

  const submitForm = () => {
    if (formRef.current) {
      fetcher.submit(formRef.current);
    }
  };

  return (
    <ActionForm
      fetcher={fetcher}
      method="patch"
      action={'/unpause_subscription'}
      formRef={formRef}
      onError={(data: any) => {
        toast.error(data?.toast?.message || 'Something went wrong, please try again');
      }}
    >
      <StatusInputs
        name="unpause_subscription"
        errorMessage={t('errors.default')}
        successMessage={t('toast.success')}
      />
      <input hidden name="subscriber_id" defaultValue={subscriberId} />
      {pauseId && <input hidden name="pause_id" defaultValue={pauseId} />}
      {tierId && <input hidden name="tier_id" defaultValue={tierId} />}
      {children({ isLoading, submitForm })}
    </ActionForm>
  );
};

export default UnpauseAction;
